import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MobileNavbar from './Elements/MobileNavbar/index.js';
import Footer from './Elements/Footer/index.js';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import Notice from './Elements/Notice/index.js';

document.title="MyEmployeeManual"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain='dev-bh31uh2m733was2a.us.auth0.com'
      clientId='bjxBXmV7pZ74OY96pvgFFoRms4eAzKAW'
      authorizationParams={{
        redirect_uri: 'https://myemployeemanual.com/account',
      }}
      logoutParams={{
        returnTo: window.location.origin,  // Change from specific URL
      }}
      cacheLocation='localstorage'
      useRefreshTokens={true}
    >
      <BrowserRouter>
        <Notice />
        <MobileNavbar />
        <App />
        <Footer />
      </BrowserRouter>
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
